import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

interface CriticalLoadingSpinnerProps {
  message?: string;
}

export const CriticalLoadingSpinner: React.FC<CriticalLoadingSpinnerProps> = ({ 
  message 
}) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 w-full h-full flex items-center justify-center bg-background">
      <div className="text-center">
        <p className="text-lg font-medium text-foreground animate-pulse">
          {message || t('loadingDiscoveries')}
        </p>
      </div>
    </div>
  );
};